import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AuthHeading, AuthLayout } from "../features/auth/components/auth-layout";
import { SignInForm } from "../features/auth/components/sign-in-form";
import { safeRedirect } from "../features/auth/guard";

export const Route = createFileRoute("/sign-in")({
  validateSearch: z.object({ redirect: z.string().optional(), error: z.string().optional() }),
  component: () => {
    const { redirect, error } = Route.useSearch();
    return (
      <AuthLayout>
        <AuthHeading title="Sign in to Repro" subtitle="Use your work email" />
        <SignInForm redirect={safeRedirect(redirect)} googleError={error} />
      </AuthLayout>
    );
  },
});
